import { render, staticRenderFns } from "./PdpCarTypesTable.vue?vue&type=template&id=247fe3e7&scoped=true"
import script from "./PdpCarTypesTable.vue?vue&type=script&lang=js"
export * from "./PdpCarTypesTable.vue?vue&type=script&lang=js"
import style0 from "./PdpCarTypesTable.vue?vue&type=style&index=0&id=247fe3e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fe3e7",
  null
  
)

/* custom blocks */
import block0 from "../translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fproduct-info-sections%2Fsubcomponents%2FPdpCarTypesTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports